module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step2_Image13.26cc57fd.jpg";